import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=6d3c4b5a"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=6d3c4b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports